module.exports = __webpack_public_path__ + "static/media/Slider.10cc8098.svg";


//////////////////
// WEBPACK FOOTER
// ./src/reusable/images/Slider.svg
// module id = 961
// module chunks = 0